import { useTranslation } from 'react-i18next';
import { QueryResult } from '@apollo/client';
import * as graphql from 'generated/graphql';

import { Container, Empty, Jumbo, Skeleton } from '@treams/treams-ui';
import useAuthenticatedUser from 'packages/kakapo-ui-application/hooks/useAuthenticatedUser';

import ViewerFeedbackTabs from './ViewerFeedbackTabs';
import ViewerFeedbackButtons from './ViewerFeedbackButtons';
import SharedFeedbackCard from './SharedFeedbackCard';
import { DialogueIcon } from '@treams/treams-icons';

function SharedFeedbackList(props: { query: QueryResult<graphql.FeedbackSharedWithUserQuery> }) {
	const { t } = useTranslation();

	return (
		<Container mb={3}>
			{props.query.data ? (
				props.query.data.user.sharedFeedback.edges.length > 0 ? (
					<>
						{props.query.data.user.sharedFeedback.edges
							.slice()
							.reverse()
							.map(({ node }) => (
								<SharedFeedbackCard key={node.request.id} {...node} />
							))}
					</>
				) : (
					<Skeleton.Empty
						contents={
							<Empty
								icon={<DialogueIcon />}
								title={t('feedback.shared.empty.title')}
								description={t('feedback.shared.empty.description')}
							/>
						}
					>
						<Skeleton.Repeat count={3}>
							<SharedFeedbackCard.Skeleton />
						</Skeleton.Repeat>
					</Skeleton.Empty>
				)
			) : (
				<Skeleton.Repeat count={10}>
					<SharedFeedbackCard.Skeleton />
				</Skeleton.Repeat>
			)}
		</Container>
	);
}

export default function SharedFeedback() {
	const { t } = useTranslation();

	const viewer = useAuthenticatedUser();
	const userID = viewer.id;

	const query = graphql.useFeedbackSharedWithUserQuery({ variables: { userID } });

	return (
		<>
			<Jumbo
				title={t('feedback.shared.title')}
				description={t('feedback.shared.description')}
				button={<ViewerFeedbackButtons />}
				footer={<ViewerFeedbackTabs />}
			/>
			<SharedFeedbackList query={query} />
		</>
	);
}
